import { Serializable } from '@/models/core/serializable';

// ある生徒のスコア推移(成長グラフ)
export class StudentCompetencyGrowth implements Serializable<StudentCompetencyGrowth> {
  competencyID: number;
  competencyName: string;
  courseResults: CourseResult[];

  deserialize(input: any): StudentCompetencyGrowth {
    this.competencyID = input.competencyID;
    this.competencyName = input.competencyName;
    // 受検結果の取得において、
    // 1. 新スコアかつスコアが0より大きい（スコアがある）もの
    // 2. 旧スコアのもの
    // この2つを画面の表示対象とするため、取込みのタイミングで選別します
    this.courseResults = input.courseResults.filter((c: CourseResult) => {
     if ((c.isNewScore && c.competencyScore > 0) || !c.isNewScore) return true
    }).map((c: CourseResult) => new CourseResult().deserialize(c));
    if (input.courseResults) {
      // API:スコアが新しい→..→古い
      // グラフ:スコアが古い→..→新しい
      // 最新の５件を取り出して、その後に古い順から先に並べ換える
      // const courseResultsDesc = input.courseResults.slice(0, 5).reverse();
      // this.courseResults = courseResultsDesc.map((competencyResult: CourseResult) => new CourseResult().deserialize(competencyResult));
    }

    return this;
  }

  get latestCourseResult(): CourseResult {
    return this.courseResults[0] || new CourseResult();
  }

  get firstCourseResult(): CourseResult {
    return this.courseResults[this.courseResults.length - 1];
  }

  get lastCourseResult(): CourseResult {
    return this.courseResults[1] || new CourseResult();
  }

  get isCompetencyScoreLess(): boolean {
    return this.latestCourseResult.competencyScore < this.lastCourseResult.competencyScore;
  }

  get scoreDiff(): number {
    return this.latestCourseResult.competencyScore - this.lastCourseResult.competencyScore;
  }
}

// 受検コース別のあるコンピテンシーのスコア
export class CourseResult implements Serializable<CourseResult> {
  competencyScore: number; // コンピテンシースコア
  giftCourseID: number; // コースID
  title: string; // コースタイトル
  examDate: Date; // 受検日(コースの開始日)
  giftCompletedCount: number = 0;
  isNewScore: boolean = false;

  deserialize(input: any): CourseResult {
    this.competencyScore = input.competencyScore;
    this.giftCourseID = input.giftCourseID;
    this.title = input.title;
    this.examDate = input.examDate;
    this.giftCompletedCount = input.giftCompletedCount;
    this.isNewScore = input.isNewScore;
    return this;
  }

  get percentScore(): number {
    return Math.floor(this.competencyScore * 100);
  }

  get scoreProgressStatus(): string {
    if (this.isNewScore) {
      // 未計測
      if (this.giftCompletedCount === 0) return '未計測';
      // 試算値
      if (this.giftCompletedCount === 1) return '試算値';
      // 参考値
      if (this.giftCompletedCount === 2) return '参考値';
      // 確定値
      return '確定値';
    }
  }
}
